<template>
<div 
    class="markdown_content"
    v-html="md_to_html"
/>
</template>

<script>

const showdown  = require('showdown');
const xss = require("xss");

export default {
    props: {
        value: {
            type: String,
            default: function() { return ""; }
        },
    },

    data() {
        return {
            converter: new showdown.Converter({
                    openLinksInNewWindow: true,
                }),

                ctrl_id: null,
        }
    },

    mounted () {
        this.ctrl_id = this.$rc.uuidv4();
            window[this.ctrl_id] = this.event_emit;
    },

    methods: {
        event_emit(event_name) {
            this.$emit(event_name);
        },

        autowireEvents(html)
        {
            let pattern = /href="#[a-zA-Z0-9-]*"/g;
            let matches = html.match(pattern);

            if ( matches == null ) return html;
            
            let ret =[];
            
            for ( let i = 0; i < matches.length; i++)
            {
                let cur_match = matches[i];
                let event = cur_match.substring('href="#'.length, cur_match.length-1);
                let replace_with = 'onclick="window[\''+this.ctrl_id+'\'](\''+event+'\')"';
                
                html = html.replaceAll(cur_match, replace_with);
            }
            
            return html;
        },

        style(html)
        {
            html = html.replaceAll("<h1>","<h1 style='margin-bottom: 15px'>");
            html = html.replaceAll("<h2>","<h2 style='margin-bottom: 3px'>");

            return html
        },
    },

    computed: {
        md_to_html() {
            let ret = xss(this.converter.makeHtml(this.value));
            return this.style(this.autowireEvents(ret));
        }
    },

}
</script>

<style lang="scss" scoped>


</style>